module.exports = __webpack_public_path__ + "media/images/themes/mandy/8-f7e9aca85fe1e481359345e3308bf536.jpg";